import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { OpenDialogChoiceClubAdminComponent } from 'app/components/dialog/open-dialog-choice-club-admin/open-dialog-choice-club-admin.component';
import { BookedOfferAdmin } from 'app/shared/models/class/bookedOffer/bookedOffer';
import { MenuAdmin } from 'app/shared/models/class/menu/menu';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { BookingSessionService } from 'app/shared/services/booking-session/booking-session.service';
import { ExportExcelFileService } from 'app/shared/services/export-excel-file/export-excel-file.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { MenuService } from 'app/shared/services/menu/menu.service';

@Component({
  selector: 'app-admin-home',
  templateUrl: './admin-home.component.html',
  styleUrls: ['./admin-home.component.scss']
})
export class AdminHomeComponent implements OnInit {

  menu: MenuAdmin[] = [];
  bookedOffersReturn: BookedOfferAdmin[];
  userConnected: any;

  constructor(
    private exportExportExecelFileService: ExportExcelFileService,
    private menuService: MenuService,
    private authService: AuthService,
    private router: Router,
    private dialog: MatDialog,
    private bookingSessionService: BookingSessionService,
    private faIconService: FaiconService,
  ) { }

  ngOnInit(): void {
    this.initComponent();
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  exportExcel(): void {

    const excelFile = [];

    switch (this.authService.getDecodedToken().role) {

      case 'admin':

        this.bookingSessionService.getBookingByClub(null).subscribe({
          next: booking => {
            booking.forEach(booked => {
              const infoBooked = {
                'Référence': booked.bookingReference,
                'Date de réservation': booked.bookingRecordDate,
                'Nombre d\'offres': booked.bookedSessionCount,
                'Nom': booked.lastName,
                'Prénom': booked.firstName,
                'Email': booked.email,
                'Montant du panier': booked.bookingAmount,
                'Accompte': booked.bookingPayedAmount || 0,
                'Reste à payer': (booked.bookingAmount - (booked.bookingPayedAmount || 0))
              };
              excelFile.push(infoBooked);
            });
            this.exportExportExecelFileService.exportAsExcelFile(excelFile, 'Réservations-LVHDF');
          }
        });
        break;

      case 'club':
        this.bookingSessionService.getBookingByClub(this.authService.getDecodedToken()?.club_code).subscribe({
          next: booking => {
            booking.forEach(booked => {
              const infoBooked = {
                'Référence': booked.bookingReference,
                'Date de réservation': booked.bookingRecordDate,
                'Nombre d\'offres': booked.bookedSessionCount,
                'Nom': booked.lastName,
                'Prénom': booked.firstName,
                'Email': booked.email,
                'Montant du panier': booked.bookingAmount,
                'Accompte': booked.bookingPayedAmount || 0,
                'Reste à payer': (booked.bookingAmount - (booked.bookingPayedAmount || 0))
              };
              excelFile.push(infoBooked);
            });
            this.exportExportExecelFileService.exportAsExcelFile(excelFile, 'Réservations-LVHDF');
          }
        });
        break;

      default:
        break;
    }
  }

  isAuthorize(roleMenu: string[]): boolean {
    // string
    return roleMenu.findIndex(r => r === this.userConnected.role) !== -1 ? true : false;

    // array
    // return this.userConnected.role.includes(roleMenu);
  }

  goToUrl(url: string) {
    const title = {
      '/admin/planning': 'planing',
      '/admin/counter': 'counter',
      '/admin/practice-place': 'praticeplace',
      '/admin/discount': 'discount',
      '/admin/resource': 'resource',
      '/admin/used-ressources': 'usedressources',
      '/admin/payments': 'payments',
      '/admin/modifications': 'modifications',
      '/admin/sessions': 'sessions'
    };

    const check = ['/admin/planning', '/admin/counter', '/admin/practice-place', '/admin/discount', '/admin/resource', '/admin/payments', '/admin/used-ressources', '/admin/modifications', '/admin/sessions'];

    switch (this.userConnected.role) {
      case 'admin':

        if (!check.includes(url)) {
          this.router.navigate([url]);
        } else {

          this.dialog.open(OpenDialogChoiceClubAdminComponent, {
            data: { url, title: title[url] },
            width: '40%',
          });
        }
        break;

      case 'club':
      case 'counter':
      case 'planning':
        this.router.navigate([url]);
        break;

      default:
        break;
    }
  }

  private initComponent(): void {
    this.menu = this.menuService.menu;
    this.userConnected = this.authService.getDecodedToken();
  }
}
